import React, { useEffect, useState } from 'react'
import onion from '../data/onion.json';
import garlic from '../data/garlik.json';
import raisins from '../data/raisins.json';
import spices from '../data/spices.json';
import vegetable from '../data/vagetable.json';
import { sendmail } from '../api';
import toast from 'react-hot-toast';


const initform = { name: "", email: "", contact: "", message: "" }
const ContactBox = () => {
    const [Product, setProduct] = useState("")
    const [subProduct, setSubProduct] = useState([]);
    const [selectedSubProduct, setselectedSubProduct] = useState({})
    const [form, setForm] = useState(initform)
    const [loading, setLoading] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(!Product) {
            toast("Please fill all details")
            return;
        }
        try {
            setLoading(true)
            const { data } = await sendmail({ ...form, url: `https://integroexim.com/${Product.toLowerCase()}/${selectedSubProduct?.id}` })
            setLoading(false)
            toast.success("Thanks For Connecting, Our team will connect you shortly")
            setForm(initform)
            setSubProduct([]);
            setProduct("")
        } catch (err) {
            setLoading(false)
        }
    }
    useEffect(() => {
        if (Product) {
            console.log(Product);
            switch (Product) {
                case "Onion":
                    setSubProduct(onion)
                    setselectedSubProduct({ id: '1', title: onion[0]?.title })
                    break;
                case "Garlic":
                    setSubProduct(garlic)
                    setselectedSubProduct({ id: '1', title: garlic[0]?.title })
                    break;
                case "Raisins":
                    setSubProduct(raisins)
                    setselectedSubProduct({ id: '1', title: raisins[0]?.title })
                    break;
                case "Spices":
                    setSubProduct(spices)
                    setselectedSubProduct({ id: '1', title: spices[0]?.title })
                    break;
                case "Vegetable":
                    setSubProduct(vegetable)
                    setselectedSubProduct({ id: '1', title: vegetable[0]?.title })
                    break;
                default:
                    break;
            }
        }
    }, [Product])

    console.log(subProduct);

    return (
        <section className="mrg_tb">
            <div className="container">

                <div className="heading d-flex flex-column justify-content-center align-items-center mb-4">
                    <h2 className="Viga text-center   wow animate__flash" data-wow-delay="0s" data-wow-duration="1s">Contact Us<span className="cl-theme"></span></h2>
                </div>

                <div className="row">

                    <div className="col-12 col-lg-6 d-flex flex-column justify-content-center align-items-start order-1 order-lg-0">

                        <div className="d-flex align-items-center my-4 wow animate__fadeInLeft" data-wow-delay="0s" data-wow-duration="1s">
                            <img src="/images/Email.png" alt="Icon of Email" draggable="false" className="img-fluid contactIcon" />
                            <div className="ps-3 ps-md-4">
                                <h4 className="Viga">Email :</h4>
                                <a href="mailto:info@integroexim.com" className="contLink">info@integroexim.com</a>
                            </div>
                        </div>
                        <div className="d-flex align-items-center my-4  wow animate__fadeInLeft" data-wow-delay="0.2s" data-wow-duration="1s">
                            <img src="/images/Call Us.png" alt="Icon of Call Us" draggable="false" className="img-fluid contactIcon" />
                            <div className="ps-3 ps-md-4">
                                <h4 className="Viga">Call Us :</h4>
                                <a href="tel:+918460024742" className="contLink">+91 84600 24742</a>
                            </div>
                        </div>
                        <div className="d-flex align-items-center my-4  wow animate__fadeInLeft" data-wow-delay="0.4s" data-wow-duration="1s">
                            <img src="/images/Address.png" alt="Icon of Address" draggable="false" className="img-fluid contactIcon" />
                            <div className="ps-3 ps-md-4">
                                <h4 className="Viga">Address :</h4>
                                <a href="https://maps.app.goo.gl/waAoPxt3W7SDADnx5" target='_blank' className="contLink">Surat, Gujarat, India</a>
                            </div>
                        </div>

                    </div>

                    <div className="col-12 col-lg-6 mt-4 mt-lg-0 order-0 order-lg-1 wow animate__fadeInUp" data-wow-delay="0.6s" data-wow-duration="1s">
                        <div className="ContBox">
                            <form onSubmit={e => handleSubmit(e)}>

                                <div className="row">
                                    <div className="col-12 contBoxLabell">
                                        <label className="contBoxLabell mb-0">Name :</label>
                                        <input required type="text" name="name" id="name" placeholder="Enter your full name here" className="form-control" value={form?.name} onChange={e => setForm(prev => { return { ...prev, name: e.target.value } })} />
                                    </div>
                                </div>

                                <div className="row mt-3">
                                    <div className="col-md-6 contBoxLabell">
                                        <label className="contBoxLabell mb-0">Email :</label>
                                        <input required type="email" name="email" id="email" placeholder="Enter your email here" className="form-control" value={form?.email} onChange={e => setForm(prev => { return { ...prev, email: e.target.value } })} />
                                    </div>
                                    <div className="col-md-6 contBoxLabell">
                                        <label className="contBoxLabell mb-0">Contact No :</label>
                                        <input required type="number" name="contactnumber" id="contactnumber" placeholder="Enter your contact no here" className="form-control" value={form?.contact} onChange={e => setForm(prev => { return { ...prev, contact: e.target.value } })} />
                                    </div>
                                </div>

                                <div className="row mt-3">
                                    <div className="col-12">
                                        <div className="dropdown position-relative">
                                            <button className="btn dropdown-toggle w-100 text-start" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                {Product || "Select Product"}
                                            </button>
                                            <ul className="dropdown-menu p-0 w-100">
                                                <li><a className="dropdown-item" onClick={e => setProduct('Onion')}>Onion</a></li>
                                                <li><a className="dropdown-item" onClick={e => setProduct('Garlic')}>Garlic</a></li>
                                                <li><a className="dropdown-item" onClick={e => setProduct('Raisins')}>Raisins</a></li>
                                                <li><a className="dropdown-item" onClick={e => setProduct('Spices')}>Spices</a></li>
                                                <li><a className="dropdown-item" onClick={e => setProduct('Vegetable')}>Vegetable</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                {Product && <div className="row mt-3">
                                    <div className="col-12">
                                        <div className="dropdown position-relative">
                                            <button className="btn dropdown-toggle w-100 text-start" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                {selectedSubProduct?.title || 'Select Sub Product'}
                                            </button>
                                            <ul className="dropdown-menu p-0 w-100">
                                                {
                                                    subProduct?.map(item => {
                                                        return <li><a className="dropdown-item" onClick={e => setselectedSubProduct({ id: item?.id, title: item?.title })}>{item?.title}</a></li>
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>}

                                <div className="row mt-3">
                                    <div className="col-md-12 contBoxLabell">
                                        <div className="form-group">
                                            <label className="contBoxLabell mb-0">Message : </label>
                                            <textarea id="comments" className="form-control" name="Enter your message here" placeholder="Message" value={form?.message} onChange={e => setForm(prev => { return { ...prev, message: e.target.value } })}></textarea>
                                        </div>
                                    </div>
                                </div>

                                <button disabled={loading} type="submit" className="navbar-btn text-center w-100 cusBtn cusSubmitBtn mt-4" style={{ "outline": "none", border: "none" }}>Submit</button>
                            </form>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default ContactBox